import React, { useCallback } from 'react'
import classNames from 'classnames'

export const Pin: React.FC<{
  className?: string
  pinned: boolean
  onPin: (arg: { pinned: boolean }) => void
}> = ({ className, pinned, onPin }) => (
  <i
    className={classNames(`icon-aytmfd-heatmap`, className, {
      [`${className}-pinned`]: pinned
    })}
    onClick={useCallback(() => {
      onPin?.({ pinned: !pinned })
    }, [onPin, pinned])}
  />
)
